import type { AppTheme } from '@backstage/core-plugin-api';
import { createUnifiedTheme, UnifiedThemeProvider } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness4';
import LightIcon from '@material-ui/icons/Brightness7';
import { karcherComponents } from './components';
import { karcherDarkPalette, karcherLightPalette } from './palettes';
import { karcherPageThemes } from './pageThemes';
import { karcherFontFamily, karcherTypography } from './typography';

const shared = {
  fontFamily: karcherFontFamily,
  typography: karcherTypography,
  pageTheme: karcherPageThemes,
  components: karcherComponents,
};

export const karcherLightTheme = createUnifiedTheme({
  ...shared,
  palette: karcherLightPalette,
});

export const karcherDarkTheme = createUnifiedTheme({
  ...shared,
  palette: karcherDarkPalette,
});

export const karcherThemes: AppTheme[] = [
  {
    id: 'karcher-light',
    title: 'Kärcher Light',
    variant: 'light',
    icon: <LightIcon />,
    Provider: ({ children }) => (
      <UnifiedThemeProvider theme={karcherLightTheme}>
        {children}
      </UnifiedThemeProvider>
    ),
  },
  {
    id: 'karcher-dark',
    title: 'Kärcher Dark',
    variant: 'dark',
    icon: <DarkIcon />,
    Provider: ({ children }) => (
      <UnifiedThemeProvider theme={karcherDarkTheme}>
        {children}
      </UnifiedThemeProvider>
    ),
  },
];

export { karcher } from './palettes';
